import React from "react";

export default function InfoImg({ small }: { small?: boolean }) {
  return (
    <svg
      width={small ? "16px" : "18"}
      height={small ? "16px" : "18"}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.16602 4.83464H9.83268V6.5013H8.16602V4.83464ZM8.16602 8.16797H9.83268V13.168H8.16602V8.16797ZM8.99935 0.667969C4.39935 0.667969 0.666016 4.4013 0.666016 9.0013C0.666016 13.6013 4.39935 17.3346 8.99935 17.3346C13.5993 17.3346 17.3327 13.6013 17.3327 9.0013C17.3327 4.4013 13.5993 0.667969 8.99935 0.667969ZM9 16.5C5 16.5 1.35682 13.168 1.5 9C1.64301 4.83709 5 1.5 9 1.5C13 1.5 16.5 5 16.5 9C16.5 13 13 16.5 9 16.5Z"
        fill="var(--vc-violet)"
      />
    </svg>
  );
}
